import { cn } from '@/lib/cn'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'ghost'
}

export default function Button({ variant = 'primary', className, ...props }: Props) {
  return (
    <button
      type="button"
      className={cn(
        'rounded-row px-5 py-3.5 text-body font-semibold transition-colors',
        'disabled:cursor-not-allowed disabled:opacity-40',
        variant === 'primary' && 'bg-field hover:bg-mark text-white',
        variant === 'ghost' && 'border-rule-strong text-ink hover:border-field border bg-card',
        className
      )}
      {...props}
    />
  )
}
